<template>
  <div>
    <h2><i>News</i></h2>

    <section>
      <div class="row">
        <div class="col-12"><i>Posted 2 days ago</i></div>
        <div class="col-12"><b>News Story Title</b><br/><br/></div>
        <div class="col-12">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,
          consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Aenean euismod bibendum laoreet.
          </br><br/>
          <a>http://www.grc.org/programs.aspx?id=16786</a>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-12"><i>Posted September 2, 2016</i></div>
        <div class="col-12"><b>News Story Title</b><br/><br/></div>
        <div class="col-xs-12 col-sm-5 col-md-4 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-7 col-md-8 col-lg-9">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,
          consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Aenean euismod bibendum laoreet.
          </br><br/>
          <a>http://www.grc.org/programs.aspx?id=16786</a>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-12"><i>Posted 2015</i></div>
        <div class="col-12"><b>News Story Title</b><br/><br/></div>
        <div class="col-12">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,
          consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Aenean euismod bibendum laoreet.
          </br><br/>
          <a>http://www.grc.org/programs.aspx?id=16786</a>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  export default {
    name: 'media',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-interact'}
      this.$parent.$parent.nextPage = false
      this.$parent.$parent.prevSlide = {name: 'article-media'}
      this.$parent.$parent.nextSlide = {name: 'article-media-twitter'}
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
  &:not(:last-child) {
     border-bottom: 1px solid #cccccc;
   }
  .img {
    border: 1px solid #cccccc;
    background-color: #eeeeee;
    width: 100%;
  &.h1 {
     height: 160px;
   }
  &.h2 {
     height: calc(320px + 0.5rem);
   }
  &.h3 {
     height: calc(480px + 1rem);
   }
  }
  }

</style>




// WEBPACK FOOTER //
// MediaNewsPage.vue?679071c6